import _ from "lodash"
import { jwtDecode } from "jwt-decode"
//import http from "../http_helper"
import {
  del,
  get,
  post,
  postReturnHeaders,
  put,
  setJwtAuthToken,
} from "../api_helper"
import { node } from "../../config.js"
import {getSession, getCurrentUser} from "../AuthType/authService"
import {
  fnConvertUTCToString,
  fnDateTimeFromSql,
  getCurrentTime,
  fnGetDateDiff,
  fnGetDateTime,
  decrypt,
  encrypt,
} from "../../common/global/functions.js"

const baseUrl =
  process.env.REACT_APP_PRODUCTION === "prod"
    ? node.baseUrl
    : process.env.REACT_APP_PRODUCTION === "stage"
    ? node.stageUrl
    : node.devUrl
const tokenKey = "token"
const session = "session"
const authUser = "authUser"
const sessionExpire = "sessionExpire"
const sessionTimeout = "sessionTimeout"

export async function fnGetMerchantUrls() {
  
  try {
    let authUrl = baseUrl + node.console.fnGetMerchantUrls.url;

    let { merchant : {pin, code} }  = getSession();
    
    let response = await post(authUrl, {
      code,
      pin,
    })
    return response
  
  } catch (ex) {    
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
        console.error({message})
    throw new Error(message)
  }
}

export async function fnGetSignups() {
  
  try {
    let url = baseUrl + node.console.fnGetSignupApplications.url;

    let { merchant}  = getSession();
    
    let response =  await post(url,{merchant})

    return response 
  
  } catch (ex) {
    console.log({ex})
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
      
    console.log({message})
    throw new Error(message)
  }
}

export async function fnShareMerchantUrlEmail(data) {
  
  try {
    let shareUrl = baseUrl + node.console.fnShareMerchantUrlEmail.url;

    let { merchant}  = getSession();

    let {email, firstname, lastname, personalized_url} = data;
    
    let response = await post(shareUrl, {email, firstname, lastname, personalized_url, merchant})

    return response; 
  
  } catch (ex) {
    console.log({ex})
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
      
    console.log({message})
    throw new Error(message)
  }
}

export async function fnShareMerchantUrlSms(data) {
  
  try {
    let smsUrl = baseUrl + node.console.fnShareMerchantUrlSms.url;

    let { merchant}  = getSession();

    let {cellphone, personalized_url} = data;
    
    let response =  await post(smsUrl,{cellphone, personalized_url, merchant})

    return response 
  
  } catch (ex) {
    console.log({ex})
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
      
    console.log({message})
    throw new Error(message)
  }
}

export async function fnInviteShareEmail(data) {
  
  try {
    let shareUrl = baseUrl + node.console.fnInviteShareEmail.url;

    let { merchant}  = getSession();

    let {email, firstname, lastname, signup_id} = data;
    
    let response = await post(shareUrl, {email, firstname, lastname, signup_id, merchant})

    return response; 
  
  } catch (ex) {
    console.log({ex})
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
      
    console.log({message})
    throw new Error(message)
  }
}

export async function fnInviteShareSms(data) {
  
  try {
    let shareUrl = baseUrl + node.console.fnInviteShareSms.url;

    let { merchant}  = getSession();

    let {cellphone, firstname, lastname, signup_id} = data;
    
    let response = await post(shareUrl, {cellphone, firstname, lastname, signup_id, merchant})

    return response; 
  
  } catch (ex) {
    console.log({ex})
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
      
    console.log({message})
    throw new Error(message)
  }
}

export async function fnConnect(data) {
  
  try {
    let connectUrl = baseUrl + node.console.fnConnect.url;

    let { merchant}  = getSession(), 
    {signup_id , co_signer : {value : co_signup_id}} = data;
    
    let response = await post(connectUrl, {co_signup_id, signup_id, merchant})

    console.log({response})

    return response; 
  
  } catch (ex) {
    console.log({ex})
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
      
    console.log({message})
    throw new Error(message)
  }
}